import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** water droplet. Decorative line icon; always pair with a visible text label. */
export function DropletIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 3.3s6.2 6.8 6.2 11a6.2 6.2 0 0 1-12.4 0c0-4.2 6.2-11 6.2-11z" />
    </IconSvg>
  )
}
